module.exports = __webpack_public_path__ + "img/s2v1.ebd3206c.jpg";